/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Endpoint_Provider_UptimeInputs */

const en_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} uptime`)
};

const zh_hans1_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`可用率 ${i?.value}`)
};

const pt_br2_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} de disponibilidade`)
};

const es_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} de disponibilidad`)
};

const fr_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} de disponibilité`)
};

const de_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} Verfügbarkeit`)
};

const ru_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Доступность: ${i?.value}`)
};

const it_endpoint_provider_uptime = /** @type {(inputs: Endpoint_Provider_UptimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} di disponibilità`)
};

/**
* | output |
* | --- |
* | "{value} uptime" |
*
* @param {Endpoint_Provider_UptimeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_provider_uptime = /** @type {((inputs: Endpoint_Provider_UptimeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Provider_UptimeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_provider_uptime(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_provider_uptime(inputs)
	if (locale === "es") return es_endpoint_provider_uptime(inputs)
	if (locale === "fr") return fr_endpoint_provider_uptime(inputs)
	if (locale === "de") return de_endpoint_provider_uptime(inputs)
	if (locale === "ru") return ru_endpoint_provider_uptime(inputs)
	if (locale === "it") return it_endpoint_provider_uptime(inputs)
	return en_endpoint_provider_uptime(inputs)
});